import './DAcLogin.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import DacLoginForm from '../DAcCreateAccount/components/DacLoginForm';
const DAcLogin = props => {
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const {
    fields,
    params
  } = props;
  const {
    data: {
      configuration,
      dictionary,
      settings
    }
  } = fields;
  const apiKey = get(settings, 'apiKey.jss.value');
  const apiUrl = get(settings, 'apiUrl.jss.value');
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "dac-login"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "dac-login__title"
  }, get(configuration, 'loginTitle.jss.value')), /*#__PURE__*/React.createElement("p", {
    className: "dac-login__description"
  }, get(configuration, 'loginDescription.jss.value')), /*#__PURE__*/React.createElement("div", {
    className: "dac-login__form-wrap"
  }, /*#__PURE__*/React.createElement(DacLoginForm, {
    dictionary: dictionary,
    isLoginComponent: true,
    configuration: configuration,
    apiConfig: {
      apiKey,
      apiUrl
    }
  }))));
};
const StyledWrapper = _ref => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
export default DAcLogin;
const commonStyles = "c14id13o";
const ltrStyles = "l1ned55i";
const rtlStyles = "rrws79b";